// extracted by mini-css-extract-plugin
module.exports = {"Language":"Language_Language__9isau"};